import HighlightBand from "../../ui/HighlightBand";
import SectionContainer from "../../ui/SectionContainer";

import { Description } from "./styles";

import SectionLogo from "../../../assets/images/sections/esp-social/logo.svg";
import Illustration from "../../../assets/images/sections/esp-social/illustration.png";
import BackgroundImage from "../../../assets/images/sections/esp-social/background.jpg";

const EspSocial = () => {
  return (
    <SectionContainer
      backgroundImage={BackgroundImage}
      id="social"
      padding="50px 20px 0px 20px"
    >
      <img src={Illustration} alt="imagem" />
      <Description>
        <img src={SectionLogo} alt="imagem" />
        <p>
          Acreditamos no esporte como agente de mudança. Por isso, a{" "}
          <strong>
            <HighlightBand background="">
              <span>ESP Social</span>
            </HighlightBand>
          </strong>{" "}
          apoia projetos sociais, ONGs e instituições que compartilham valores
          do bem e incentivam o futebol como ferramenta de transformação.
        </p>
      </Description>
    </SectionContainer>
  );
};

export default EspSocial;
